import React from 'react';
import TextField from 'shared/components/text-field/TextField';

class CreateFoodForm extends React.Component {
  render() {
    return (
      <div className="form-content">
        <TextField
          type="text"
          name="name"
          label="Food Title"
          placeholder="Meal Name"
        />
      </div>
    );
  }
}

export default CreateFoodForm;
